import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";
import { fmtDate  } from "../../lib/format";
import { errText } from "../../lib/errors";

const EMPTY = { code: "", type: "percent", value: 10, min_cart: 0, max_uses: "", ends_at: "" };
const inputCls = "h-11 px-4 rounded-xl border border-stone-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-forest/30";

export default function AdminCoupons() {
  const [items, setItems] = useState([]);
  const [f, setF] = useState(EMPTY);
  const load = () => api.get("/admin/coupons").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/coupons", { ...f, value: Number(f.value), min_cart: Number(f.min_cart), max_uses: f.max_uses === "" ? null : Number(f.max_uses), ends_at: f.ends_at || null });
      toast.success("Kupon oluşturuldu");
      setF(EMPTY);
      load();
    } catch (err) { toast.error(errText(err) || "Oluşturulamadı"); }
  };

  const del = async (code) => {
    if (!window.confirm(`${code} silinsin mi?`)) return;
    await api.delete(`/admin/coupons/${code}`);
    load();
  };

  return (
    <div data-testid="admin-coupons-page">
      <h1 className="font-serif text-2xl sm:text-3xl text-forest">Kuponlar</h1>
      <form onSubmit={submit} className="mt-6 bg-white rounded-2xl border border-stone-200/80 p-5 grid grid-cols-2 sm:grid-cols-6 gap-3 items-end shadow-sm">
        <div className="col-span-2 sm:col-span-1"><label className="text-xs font-semibold text-stone-500">Kod</label><input data-testid="coupon-code-input" required className={`${inputCls} w-full uppercase`} value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} /></div>
        <div><label className="text-xs font-semibold text-stone-500">Tip</label>
          <select className={`${inputCls} w-full`} value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })}>
            <option value="percent">Yüzde (%)</option><option value="fixed">Sabit (TL)</option>
          </select>
        </div>
        <div><label className="text-xs font-semibold text-stone-500">Değer</label><input data-testid="coupon-value-input" type="number" required className={`${inputCls} w-full`} value={f.value} onChange={(e) => setF({ ...f, value: e.target.value })} /></div>
        <div><label className="text-xs font-semibold text-stone-500">Min. Sepet</label><input type="number" className={`${inputCls} w-full`} value={f.min_cart} onChange={(e) => setF({ ...f, min_cart: e.target.value })} /></div>
        <div><label className="text-xs font-semibold text-stone-500">Max Kullanım</label><input type="number" className={`${inputCls} w-full`} value={f.max_uses} onChange={(e) => setF({ ...f, max_uses: e.target.value })} /></div>
        <button data-testid="coupon-create-button" className="flex items-center justify-center gap-2 bg-forest hover:bg-forest-dark text-white text-sm font-semibold py-2.5 rounded-xl transition-colors"><Plus className="w-4 h-4" /> Ekle</button>
      </form>
      <div className="bg-white rounded-2xl border border-stone-200/80 mt-5 overflow-x-auto shadow-sm">
        <table className="w-full text-sm min-w-[560px]">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-stone-400 border-b border-stone-100"><th className="p-4">Kod</th><th className="p-4">İndirim</th><th className="p-4">Min. Sepet</th><th className="p-4">Kullanım</th><th className="p-4">Oluşturma</th><th className="p-4"></th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.code} data-testid={`coupon-row-${c.code}`} className="border-b border-stone-50">
                <td className="p-4 font-mono font-bold">{c.code}</td>
                <td className="p-4">{c.type === "percent" ? `%${c.value}` : `${c.value} TL`}</td>
                <td className="p-4">{c.min_cart} TL</td>
                <td className="p-4">{c.used_count}{c.max_uses ? ` / ${c.max_uses}` : ""}</td>
                <td className="p-4 text-stone-500">{fmtDate(c.created_at)}</td>
                <td className="p-4 text-right"><button data-testid={`coupon-delete-${c.code}`} onClick={() => del(c.code)} className="p-2 rounded-lg hover:bg-red-50 text-terra"><Trash2 className="w-4 h-4" /></button></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-stone-400">Kupon yok</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
